import { API } from 'aws-amplify';

import {
	FETCH_NI_SMELTER_PRODUCTION,
	FETCH_NI_SMELTER_PRODUCTION_ERR,
	RESET_NI_SMELTER_PRODUCTION,
	FETCH_NI_MTD_PRODUCTION,
	FETCH_NI_MTD_PRODUCTION_ERR,
	FETCH_NI_PRODUCTION_BY_SMELTER,
	FETCH_NI_PRODUCTION_BY_SMELTER_ERR,
	RESET_NI_PRODUCTION_BY_SMELTER,
	SELECT_NI_PROD_SMELTER,
	UNSELECT_NI_PROD_SMELTER,
	RESET_NI_PROD_SMELTERS
} from '../';
import config from '../../config';
import { replacer } from '../../utils';
import { clearApiRetry, showApiMessages } from '../../apiMessages';

export const fetchNiSmelterProduction =
	({
		grouping,
		id = '',
		collapse,
		ute = '',
		capAdd = '',
		startDate = '',
		endDate = ''
	}) =>
	async (dispatch, getState) => {
		const retryKey = JSON.stringify({
			grouping,
			id,
			collapse,
			ute,
			capAdd,
			startDate,
			endDate
		});
		clearApiRetry('Nickel production', retryKey);
		const request = API.get(
			'gains-api',
			replacer(config.apiEndpoints.niSmelterProduction, {
				grouping,
				id,
				collapse,
				ute,
				capAdd,
				startDate,
				endDate
			}),
			{
				headers: {}
			}
		);

		return request.then(
			(response) => {
				showApiMessages({
					retryKey,
					response,
					sites: getState ? getState().sites : [],
					title: 'Nickel production'
				});
				dispatch({
					type: FETCH_NI_SMELTER_PRODUCTION,
					payload: {
						[collapse]:
							response.combinedIdx || response.singleIdx?.[0]?.data || []
					}
				});
			},
			(err) => {
				showApiMessages({
					retryKey,
					response: { error: err },
					title: 'Nickel production',
					onRetry: () => dispatch(fetchNiSmelterProduction({
						grouping,
						id,
						collapse,
						ute,
						capAdd,
						startDate,
						endDate
					}))
				});
				return dispatch({
					type: FETCH_NI_SMELTER_PRODUCTION_ERR,
					payload: err
				});
			}
		);
	};
export const resetNiSmelterProduction = () => (dispatch) => {
	clearApiRetry('Nickel production');
	return dispatch({ type: RESET_NI_SMELTER_PRODUCTION });
};

export const fetchNiMtdProduction =
	({ grouping, id = '', ute = '' }) =>
	async (dispatch, getState) => {
		const retryKey = JSON.stringify({
			grouping,
			id,
			ute
		});
		clearApiRetry('Nickel month-to-date production', retryKey);
		const request = API.get(
			'gains-api',
			replacer(config.apiEndpoints.niMtdProduction, {
				grouping,
				id,
				ute
			}),
			{
				headers: {}
			}
		);

		return request.then(
			(response) => {
				showApiMessages({
					retryKey,
					response,
					sites: getState ? getState().sites : [],
					title: 'Nickel month-to-date production'
				});
				dispatch({
					type: FETCH_NI_MTD_PRODUCTION,
					payload: response
				});
			},
			(err) => {
				showApiMessages({
					retryKey,
					response: { error: err },
					title: 'Nickel month-to-date production',
					onRetry: () => dispatch(fetchNiMtdProduction({
						grouping,
						id,
						ute
					}))
				});
				return dispatch({
					type: FETCH_NI_MTD_PRODUCTION_ERR,
					payload: err
				});
			}
		);
	};

export const resetNiMtdProduction = () => {
	clearApiRetry('Nickel month-to-date production');
	return {
		type: FETCH_NI_MTD_PRODUCTION,
		payload: []
	};
};

export const fetchNiProductionBySmelter =
	({ ids, collapse, ute = '', startDate = '', endDate = '' }) =>
	async (dispatch, getState) => {
		const retryKey = JSON.stringify({
			ids,
			collapse,
			ute,
			startDate,
			endDate
		});
		clearApiRetry('Nickel site production', retryKey);
		const request = API.get(
			'gains-api',
			replacer(config.apiEndpoints.niProductionBySmelters, {
				ids,
				collapse,
				ute,
				startDate,
				endDate
			}),
			{
				headers: {}
			}
		);

		return request.then(
			(response) => {
				showApiMessages({
					retryKey,
					response,
					sites: getState ? getState().sites : [],
					title: 'Nickel site production'
				});
				return dispatch({
					type: FETCH_NI_PRODUCTION_BY_SMELTER,
					payload: response
				});
			},
			(err) => {
				showApiMessages({
					retryKey,
					response: { error: err },
					title: 'Nickel site production',
					onRetry: () => dispatch(fetchNiProductionBySmelter({
						ids,
						collapse,
						ute,
						startDate,
						endDate
					}))
				});
				return dispatch({
					type: FETCH_NI_PRODUCTION_BY_SMELTER_ERR,
					payload: err
				});
			}
		);
	};

export const resetNiProductionBySmelter = () => {
	clearApiRetry('Nickel site production');
	return {
		type: RESET_NI_PRODUCTION_BY_SMELTER,
		payload: {}
	};
};

export const selectNiProdSmelter = (key) => ({
	type: SELECT_NI_PROD_SMELTER,
	payload: key
});

export const unselectNiProdSmelter = (key) => ({
	type: UNSELECT_NI_PROD_SMELTER,
	payload: key
});

export const resetNiProdSmelters = () => ({
	type: RESET_NI_PROD_SMELTERS
});
